import styled from 'styled-components';

const Wrapper = styled.div `
    display: inline-flex;
    gap: 7px;
`;

export { Wrapper };
//# sourceMappingURL=InputHelperLabel.styles.js.map
